<!--  -->
<template>
    <div class='content'>
        <div class="table">
            <div class="table_list">
                <el-row :gutter="10" >
                    <el-col :span="3" v-for="(item, index) in tableList" :key="index">
                        <div class="grid-content bg-purple table_item" :class="tableFilter(item, 1)">
                            <div @click="gettableDetail(item)" class="table_num" v-if="LT == 'zh'">{{ item.name }}号桌</div>
                            <div @click="gettableDetail(item)" class="table_num" v-else>Table {{ item.name }}</div>
                            <div class="table_price">{{ tableFilter(item, 2) }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="button">
                <!-- <el-button @click="dialogVisible = true" type="info">结束营业</el-button> -->
                <el-button @click="tableSet" type="info">{{ language['桌台设置'][LT] }}</el-button>
            </div>
        </div>
        <!-- 结束营业start -->
        <el-dialog :visible.sync="dialogVisible" width="30%" :show-close="true">
            <span>{{ language['确定要结束营业吗?'][LT] }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ language['取消'][LT] }}</el-button>
                <el-button type="primary" @click="closebusiness">{{ language['确定'][LT] }}</el-button>
            </span>
        </el-dialog>
        <!-- 结束营业end -->
        <!-- 桌台设置 -->
        <el-dialog :title="language['桌台设置'][LT]" :visible.sync="tableVisible" width="50%">
            <div class="table_set">
                <!-- <div class="confirm">
                    <el-button type="primary" @click="getTableSet">确定</el-button>
                </div> -->
                <div class="set" style="padding: 20px 10% 0;">
                    <el-table :empty-text="language['暂无数据'][LT]" :data="setTableList" style="width: 100%" border>
                        <el-table-column :label="language['桌号'][LT]" width="80" align="center">
                            <template slot-scope="scope">
                                <span style="margin-left: 10px">{{ scope.row.table_id }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="language['操作'][LT]" align="center">
                            <template slot-scope="scope">
                                <el-radio-group v-model="scope.row.status" @input="getChnageStatus(scope.row)">
                                    <el-radio style="margin-right: 30px;" :label="1">{{ language['可用'][LT] }}</el-radio>
                                    <el-radio :label="0">{{ language['不可用'][LT] }}</el-radio>
                                </el-radio-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
        <!-- 桌台设置结束 -->
        <!-- 桌号订单详情 -->
        <el-dialog :title="language['订单详情'][LT]" :visible.sync="tableDetailShow" width="70%">
            <div class="tableDetail">
                <div class="table_info">
                    <div class="table_infos">
                        <div class="table_people_num">
                            <div>{{ language['人数'][LT] }}</div>
                            <div>
                                <span class="num_color">{{ tableDetail.info.person_num }}</span>
                                <span>{{ language['人'][LT] }}</span>
                            </div>
                        </div>
                        <div class="table_people_num">
                            <div>{{ language['桌号'][LT] }}</div>
                            <div>
                                <span class="num_color">{{ tableDetail.table_id }}</span>
                                <span>{{ language['号'][LT] }}</span>
                            </div>
                        </div>
                        <div class="table_people_num">
                            <div>{{ language['合计(元)'][LT] }}</div>
                            <div>
                                <span>{{ tableDetail.info.total_money }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="table_btn">
                        <el-button class="btn" type="primary" @click="checkoutShow = true">{{ language['结账'][LT]
                        }}</el-button>
                        <el-button class="btn" type="primary" @click="addDishShow = true">{{ language['加菜'][LT]
                        }}</el-button>
                        <el-button class="btn" type="primary" :loading="loading" @click="getPrinttiket">{{
                            language['打印小票'][LT] }}</el-button>
                    </div>
                </div>
                <div class="order_list">
                    <div class="order_item" v-for="(item1, index1) in  tableDetail.list " :key="index1">
                        <div class="table_title">
                            <span class="bold"></span>
                            <h3>{{ item1.sort == 1 ? language['点餐信息'][LT] : language['加单'][LT] }}</h3>
                        </div>
                        <div class="table_order_info">
                            <div class="order_info">
                                <span>{{ language['点餐时间'][LT] }}: {{ item1.create_time }}</span>
                                <span>{{ language['金额'][LT] }}:</span>
                                <span>￥{{ item1.payable_money }}</span>
                            </div>
                        </div>
                        <div class="table_table_list">
                            <el-table :empty-text="language['暂无数据'][LT]" border
                                :header-cell-style="{ background: 'rgb(243,246,253)' }" :span-method="objectSpanMethod"
                                :data="item1.order_goods_list" style="width: 100%">
                                <el-table-column :label="language['序号'][LT]" align="center" width="80">
                                    <template slot-scope="scope">
                                        <div class="num_tip" style="text-align: center;justify-content: center;">
                                            {{ index1 == 0 && scope.$index ==
                                                item1.order_goods_list.length - 1 ? ''
                                                : scope.$index + 1 }}
                                        </div>
                                    </template>

                                </el-table-column>
                                <el-table-column prop="name" :label="language['商品'][LT]" align="center"
                                    width="180"></el-table-column>
                                <el-table-column prop="address" :label="language['数量'][LT]" align="center" width="150">
                                    <template slot-scope="scope">
                                        <div class="num_tip">
                                            <i class="el-icon-minus"
                                                @click="getChangeNum(index1, scope.$index, scope.row, scope.row.num - 1)"></i>
                                            <!-- <span>{{ scope.row.num }}</span> -->
                                            <el-input type="number" v-model="scope.row.num" @change="getChangeNum(index1, scope.$index, scope.row,scope.row.num)"></el-input>
                                            <i class="el-icon-plus"
                                                @click="getChangeNum(index1, scope.$index, scope.row, Number(scope.row.num) + 1)"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="price" :label="language['单价'][LT]" align="center"></el-table-column>
                                <el-table-column prop="total_money" :label="language['小计'][LT]"
                                    align="center"></el-table-column>
                                <el-table-column prop="address" :label="language['操作'][LT]" align="center">
                                    <template slot-scope="scope"
                                        v-if="(index1 == 0 && scope.$index != tableDetail.list[0].order_goods_list.length - 1) || index1 > 0">
                                        <el-button @click="getDeleteGood(scope.row)" type="text" size="small">{{
                                            language['删除'][LT] }}</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 桌号订单详情结束 -->

        <!-- 结账 -->
        <el-dialog :title="language['结账详情'][LT]" :visible.sync="checkoutShow" width="50%">
            <div class="checkout">
                <div class="checkout_type">
                    <div class="pay" @click="getChangePayType('现金')" :class="{ payActive: pay_type == '现金' }">{{
                        language['现金支付'][LT] }}</div>
                    <div class="pay" @click="getChangePayType('pos')" :class="{ payActive: pay_type == 'pos' }">{{
                        language['POS支付'][LT] }}
                    </div>
                    <div class="pay" @click="getChangePayType('扫码')" :class="{ payActive: pay_type == '扫码' }">{{
                        language['扫码支付'][LT] }}</div>
                    <!-- <div class="pay" @click="getChangePayType('会员卡结账')" :class="{ payActive: pay_type == '会员卡结账' }">{{
                        language['会员卡结账'][LT] }}</div> -->
                </div>
                <div v-if="pay_type == '会员卡结账'" >
                    <div style="font-weight: bold;margin: 24px 0;color: #333;">{{ language['会员详情'][LT] }}</div>
                    <div class="memberDetails">
                        <span style="width: 90px;text-align: right;">{{ language['会员手机号'][LT] }}</span>
                        <el-input class="inputStyle" v-model="mobileNum"
                            :placeholder="language['请输入会员手机号'][LT]" @change="getMemberInput()"></el-input>
                    </div>
                    <div class="memberDetails">
                        <span style="width: 90px;text-align: right;"> {{ language['会员姓名'][LT] }}</span>
                        <el-input class="inputStyle" :disabled="true" v-model="memberDatares.name"></el-input>
                    </div>
                    <div class="memberDetails">
                        <span style="width: 90px;text-align: right;"> {{ language['现有余额'][LT] }}</span>
                        <el-input class="inputStyle" :disabled="true" v-model="memberDatares.money"></el-input>
                    </div>
                    <!-- 余额不足 -->
                    <div v-if="deficiency">
                        <div class="memberDetails">
                        <span style="width: 90px;text-align: right;">{{ language['抵扣金额'][LT] }}</span>
                        <el-input class="inputStyle" v-model="deduction" :disabled="true" ></el-input>
                        </div>
                        <div class="memberDetails">
                            <span style="width: 90px;text-align: right;">{{ language['还需支付金额'][LT] }}</span>
                            <el-input class="inputStyle" v-model="paymentAmount"></el-input>
                        </div>
                        <div class="memberDetails">
                            <span style="width: 90px;text-align: right;margin-right: 12px;">{{ language['组合付方式'][LT] }}</span>
                            <el-radio v-model="rechargeType" label="现金">{{ language['现金支付'][LT] }}</el-radio>
                            <el-radio v-model="rechargeType" label="pos">{{ language['POS机支付'][LT] }}</el-radio>
                            <el-radio v-model="rechargeType" label="扫码">{{ language['扫码支付'][LT] }}</el-radio>
                        </div>
                        <div style="margin-left: 160px;color: red;">{{ `提示：您的会员余额不足，可抵扣金额为${deduction || 0}，还需支付${paymentAmount}` }}</div>
                    </div>
                </div>
                <div class="checkout_info">
                    <div class="price">
                        <span>{{ language['金额'][LT] }}</span>
                        <span>
                          ￥{{ tableDetail.info.total_money }}</span>
                    </div>
                    <!-- <div class="price">
                        <span>{{ language['服务税'][LT] }}</span>
                        <span>￥{{ (tableDetail.info.total_money * 0.1).toFixed(2) }}</span>
                    </div>
                    <div class="price">
                        <span>{{ language['政府税'][LT] }}</span>
                        <span>￥{{ (tableDetail.info.total_money *0.06).toFixed(2) }}</span>
                    </div> -->
                    <div class="price">
                        <span>{{ language['优惠金额'][LT] }}</span>
                        <el-input class="input" :disabled="disabled" v-model="coupon_money"
                            placeholder="请输入优惠金额" @change="discountsChange()"></el-input>
                        <!-- <span>￥122</span> -->
                        <i class="el-icon-edit" @click="disabled = false"></i>
                    </div>
                    <el-button class="btns" :loading="loading" @click="goTopUp" type="info" v-if="deficiency">{{ language['充值'][LT] }}</el-button>
                    <el-button class="btns" :loading="loading" @click="getcheckout" type="primary" >{{ language['确定'][LT] }}</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 结账结束 -->

        <!-- 加菜 -->

        <el-dialog :title="language['订单详情'][LT]" :visible.sync="addDishShow" width="95%">
            <div class="add_dish">
                <div class="dining">
                    <div class="dining_num">
                        <div>{{ language['人数'][LT] }}</div>
                        <div>
                            <!-- <el-input type="number" class="inputs" v-model="tableDetail.info.person_num"></el-input> -->
                            <span class="color_red" :class="{ useinput: contenteditable }"
                                :contenteditable="contenteditable">{{ tableDetail.info.person_num
                                }}</span>
                            <span>人</span>
                            <i class="el-icon-edit edit" @click="contenteditable = !contenteditable"></i>
                        </div>
                    </div>
                    <div class="dining_num">
                        <div> {{ language['桌号'][LT] }}</div>
                        <div>
                            <span class="color_red">{{ table_id }}</span>
                            <span> {{ language['号'][LT] }}</span>
                        </div>
                    </div>
                </div>
                <div class="diancan">
                    <div class="dining_info">
                        <h3>{{ language['点餐信息'][LT] }}</h3>
                        <div class="order">
                            <div class="classification">
                                <div class="classification_item" @click="getChangeDishes(item1, index)"
                                    :class="{ 'dishes_active': dishesType == item1.id }"
                                    v-for="( item1, index1 ) in  dishesTypeList " :key="index1">
                                    {{ item1.name }}
                                </div>
                            </div>
                            <div class="goods">
                                <div class="good_item" v-for="( item2, index2 ) in  goodList " :key="index2">
                                    <div class="good_img_div">
                                        <img class="good_img" :src="item2.image" alt="">
                                        <div v-if="item2.status == 0">{{ language['已售罄'][LT] }}</div>
                                    </div>
                                    <div class="good_name">{{ item2.name }}</div>
                                    <div class="good_info">
                                        <span>￥{{ item2.price }}</span>
                                        <i class="el-icon-shopping-cart-2" @click="getAddCar(item2)"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="add_order">
                                <div class="add_order_tip"> {{ language['加单'][LT] }}</div>
                                <el-table :empty-text="language['暂无数据'][LT]" :data="shopCarList" style="width: 100%">
                                    <el-table-column prop="id" label="ID" align="center" width="80"> </el-table-column>
                                    <el-table-column prop="name" :label="language['商品'][LT]"
                                        align="center"></el-table-column>
                                    <el-table-column prop="num" :label="language['数量'][LT]" align="center" width="130">
                                        <template slot-scope="scope">
                                            <div class="add_goods">
                                                <i class="el-icon-minus" @click="getreduce(scope.row, scope.$index)"></i>
                                                <!-- <span>{{ scope.row.num }}</span> -->
                                                <el-input type="number" v-model="scope.row.num"></el-input>
                                                <i class="el-icon-plus" @click="getAddGoodNum(scope.row, scope.$index)"></i>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="price" :label="language['单价'][LT]" align="center"
                                        width="100"></el-table-column>
                                    <el-table-column prop="address" :label="language['小计'][LT]" align="center" width="80">
                                        <template slot-scope="scope">
                                            <div class="add_goods">
                                                <span>{{ language['￥'][LT] }}{{ getFillterPrice(scope.row.num,
                                                    scope.row.price) }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="count">
                                    <div class="count_info">
                                        <div class="goods_order_num">{{ language['共'][LT] }} {{ allGoodNum }} {{
                                            language['件商品'][LT] }}</div>
                                        <div class="goods_order_nums">
                                            <span> {{ language['合计：'][LT] }}</span>
                                            <span>￥{{ allPrice }}</span>
                                        </div>
                                    </div>
                                    <div class="immediately" :loading="loading" @click="getPlaceOrder"> {{
                                        language['立即加菜'][LT] }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </el-dialog>

        <!-- 加菜结束 -->
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dialogVisible: false,
            tableVisible: false, //桌台设置弹窗
            tableDetailShow: false, //桌台详情
            checkoutShow: false,//结账
            addDishShow: false, //加菜弹窗
            activeIndex: 1,
            tableData: [{
                name: '01',
            }],
            radio: 1,
            tableList: [], //桌台列表
            shopDetail: {},//店铺详情
            tableDetail: { info: { person_num: '' } },//桌台订单详情
            setTableList: [], //显示设置桌台弹窗数据
            table_id: '', //桌台id
            pay_type: '现金', //支付方式
            coupon_money: 0,//优惠金额
            disabled: true,
            dishesTypeList: [],//菜品分类列表
            dishesType: '', //菜品分类
            goodList: [],//商品列表
            shopCarList: [], //购物车列表
            allGoodNum: 0,//商品数量
            allPrice: 0,//购物车总金额
            contenteditable: false,//是否可以修改
            loading: false,
            mobileNum:'',//会员手机号
            memberDatares:{name:'',money:0},
            rechargeType:'现金',
            deficiency:false,
            paymentAmount:0,//还需支付金额
            paymentAmountTotal:0,//还需支付金额
            deduction:0//抵扣金额
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

        discountsChange(){
          if(this.pay_type == '会员卡结账'){
            if(this.coupon_money > 0){
              this.paymentAmount = this.paymentAmount - this.coupon_money
              this.paymentAmountTotal = this.paymentAmount - this.coupon_money
            }else{
              let num = this.tableDetail.info.total_money - this.memberDatares.money
              this.paymentAmountTotal = num.toFixed(2)
              this.paymentAmount = num.toFixed(2)
            }
          }
            // this.paymentAmount = this.tableDetail.info.total_money - this.coupon_money
            // if(Number(this.paymentAmount) < 0){
            //     this.paymentAmount = 0
            //     this.coupon_money = this.paymentAmountTotal
            // }
        },
        // 去充值
        goTopUp(){
            this.$router.push({ path: `/memberList?mobile=${this.mobileNum}` })
        },
        // 会员列表
        getMemberInput() {
            this.$post('64e80f2aa504c', { mobile: this.mobileNum }).then(res => {
                if (res.code == 1 && res.data.id) {
                    // console.log('会员详情', res);
                        this.memberDatares = res.data
                        if(Number(this.tableDetail.info.total_money) > Number(this.memberDatares.money)){
                            this.deficiency = true
                            let num = this.tableDetail.info.total_money - this.memberDatares.money
                            // this.paymentAmountTotal = num.toFixed(2)
                            this.paymentAmount = num.toFixed(2)
                            this.deduction = this.memberDatares.money
                        }
                    // this.tableData = res.data.data
                }else{
                        this.memberDatares = {
                            name:'',
                            money:0
                        }
                        this.deficiency = false
                    }
            })
        },
        // 桌台列表
        getTableList() {
            this.$post('64c0f71d83b03').then(res => {
                if (res.code == 1) {
                    console.log('桌台列表', res)
                    this.tableList = res.data;


                }
            })
        },
        // 选择菜品分类
        getChangeDishes(item, index) {
            this.dishesType = item.id;
            this.getGoodList();
        },
        // 获取商品列表
        getGoodList() {
            this.$post('64c0e62c111cc', { cate_id: this.dishesType }).then(res => {
                if (res.code == 1) {
                    console.log('商品列表', res);
                    this.goodList = res.data;
                }
            })
        },
        // 菜品分类
        getDishesType() {
            this.$post('64c0e52b39cd5').then(res => {
                if (res.code == 1) {
                    console.log('菜品分类'.res);
                    this.dishesTypeList = res.data;
                    this.dishesType = this.dishesTypeList[0].id;
                    this.getGoodList();
                }
            })
        },
        // 添加购物车
        getAddCar(item) {
            this.$post('64c0fafdbebc8', { table_id: this.table_id, goods_id: item.id, num: 1 }).then(res => {
                if (res.code == 1) {
                    console.log('添加购物车成功', res)
                    this.getShopCar();
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 购物车列表
        getShopCar() {
            this.$post('64c1d35d3ac6a', { table_id: this.table_id }).then(res => {
                if (res.code == 1) {
                    console.log('购物车列表', res)
                    this.shopCarList = res.data;
                    this.allGoodNum = this.shopCarList.length;
                    let allPrice = 0;
                    this.shopCarList.map(item => {
                        allPrice += item.num * item.price
                    })
                    this.allPrice = allPrice.toFixed(2);
                }
            })
        },
        // 添加购物车商品数量
        getAddGoodNum(item, index) {
            console.log(item, index)
            this.$post('64c0fafdbebc8', { table_id: this.table_id, goods_id: item.goods_id, num: 1 }).then(res => {
                if (res.code == 1) {
                    console.log('添加数量', res);
                    // this.shopCarList[index].num++;
                    this.getShopCar();
                }
            })
        },
        // 减少购物车商品数量
        getreduce(item, index) {
            this.$post('64c0fafdbebc8', { table_id: this.table_id, goods_id: item.goods_id, num: -1 }).then(res => {
                if (res.code == 1) {
                    console.log('添加数量', res);
                    this.getShopCar();
                }
            })
        },
        // 价格计算
        getFillterPrice(num, price) {
            return (num * price).toFixed(2)
        },
        // 立即下单
        getPlaceOrder() {
            this.loading = true;
            this.$post('64c1e05dbe7d1', { table_id: this.table_id, person_num: this.tableDetail.info.person_num }).then(res => {
                if (res.code == 1) {
                    console.log('下单成功', res);
                    this.loading = false;
                    this.$message({
                        message: this.language['加菜成功'][this.LT],
                        type: 'success'
                    });
                    this.gettableDetail({ table_id: this.table_id })
                    setTimeout(() => {
                        this.addDishShow = false;
                        this.gettableDetail();
                    }, 500);

                } else {
                    this.loading = false;
                }
            })
        },
        // 桌台设置弹窗显示
        tableSet() {
            this.tableVisible = true;
            this.setTableList = this.tableList;
            console.log(this.setTableList);
        },
        // 设置桌台状态
        getChnageStatus(item) {
            console.log(item)
            // 桌台信息 {table:桌台id,status:状态0不可用1可用}
            // let arr = [];
            // this.setTableList.map(item => {
            //     let obj = {
            //         table_id: item.table_id,
            //         status: item.status
            //     }
            //     arr.push(obj)
            // })
            this.$post('64c213048b774', { table_id: item.table_id, status: item.status }).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: this.language['设置成功'][this.LT],
                        type: 'success'
                    });
                    // this.tableList = this.setTableList;
                    this.tableVisible = false;
                }
            })
        },
        // 桌台详情
        gettableDetail(item) {
            if (item.status == 0 || (item.status == 1 && item.is_free == 1)) {
                return false;
            }
            this.table_id = item.table_id
            this.$post('64c1e662f3a67', { table_id: item.table_id }).then(res => {
                if (res.code == 1) {
                    console.log('桌台详情', res);
                    this.tableDetail = res.data;
                    this.tableDetail.table_id = item.table_id;
                    this.tableDetailShow = true;
                    this.tableDetail.list.map(item => {
                        if (item.sort == 1) {
                            item.order_goods_list.push({ id: '', name: this.language['餐位费'][this.LT], num: this.tableDetail.info.person_num, price: this.tableDetail.info.seat_fee / this.tableDetail.info.person_num, total_money: this.tableDetail.info.seat_fee })
                        }
                    })
                    this.getShopCar();
                }
            })
        },
        // 修改菜单物品数量
        getChangeNum(index, index1, item, num) {
            console.log(index, index1, item);
            if (index == 0 && index1 + 1 == this.tableDetail.list[index].order_goods_list.length) {
                this.$post('64c1f20171968', { table_id: this.table_id, person_num: num }).then(res => {
                    this.$message({
                        message: this.language['修改成功'][this.LT],
                        type: 'success'
                    });
                    this.gettableDetail({ table_id: this.table_id })
                    // this.tableDetail.list[index].order_goods_list[index1].num = num;
                    // this.tableDetail.list[index].order_goods_list[index].total_money = this.tableDetail.list[index].order_goods_list[index1].num * this.tableDetail.info.seat_fee
                    // this.gettableDetail();
                })
            } else {
                this.$post('64c1ee4e0a66e', { id: item.id, num: num }).then(res => {
                    this.$message({
                        message: this.language['修改成功'][this.LT],
                        type: 'success'
                    });
                    this.gettableDetail({ table_id: this.table_id })
                    // this.gettableDetail();
                })
            }

        },
        // 删除
        getDeleteGood(item) {
            this.$post('64ce1e2325902', { id: item.id }).then(res => {
                if (res.code == 1) {
                    console.log('删除菜单商品', res);
                    this.$message({
                        message: this.language['删除成功'][this.LT],
                        type: 'success'
                    });
                    this.$post('64c1e662f3a67', { table_id: this.table_id }).then(reg => {
                        if (res.code == 1) {
                            console.log('桌台详情', reg);
                            this.tableDetail = reg.data;
                            this.tableDetailShow = true;
                        }
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 桌台过滤
        tableFilter(item, type) {
            if (item.status == 1) {
                if (item.is_free == 1) {
                    // 空闲
                    return type == 1 ? 'is_free' : this.language['空闲'][this.LT]
                } else {
                    // 使用中
                    return type == 1 ? 'useing' : (item.money || 0)
                }
            } else {
                return type == 1 ? 'no_use' : this.language['不可用'][this.LT]
            }
        },
        // 打印小票
        getPrinttiket() {
            this.loading = true
            this.$post('64cb4a6d555f1', { table_id: this.table_id }).then(res => {
                if (res.code == 1) {
                    this.loading = false;
                    this.$message({
                        message: this.language['打印成功'][this.LT],
                        type: 'success'
                    });
                } else {
                    this.loading = false;
                    this.$message.error(res.msg);
                }
            })
        },
        // 选择支付方式
        getChangePayType(type) {
            this.pay_type = type
        },
        // 结账
        getcheckout() {
            if(this.pay_type == '会员卡结账' && !this.member_name && !this.mobileNum)return this.$message.info('请输入会员信息')
            if (Number(this.coupon_money) > Number(this.tableDetail.info.total_money)) {
                this.$message.error(this.language['优惠金额不能大于订单价格'][this.LT]);
                return false;
            }
            this.loading = true;
            let data = {
                pay_type: this.pay_type,
                coupon_money: this.coupon_money,
                table_id: this.table_id,
                mobile:this.mobileNum,
                vip_pay_type:'',
                money:''
            }
            if(this.pay_type == '会员卡结账' &&  this.coupon_money < this.tableDetail.info.total_money ){
              data.vip_pay_type = this.rechargeType,
              data.money = this.paymentAmount
            }
            console.log('结账',data);
            this.$post('64c2266c49369', data).then(res => {
                if (res.code == 1) {
                    console.log('结账成功', res);
                    this.loading = false;
                    this.checkoutShow = false;
                    this.tableDetailShow = false;
                    this.coupon_money = 0;
                    this.getTableList();
                    this.$message({
                        message: this.language['结账成功'][this.LT],
                        type: 'success'
                    });

                } else {
                    this.loading = false;
                    this.$message.error(res.msg);
                }
            })
        },
        // 合并单元格
        objectSpanMethod(row, column, rowIndex, columnIndex) {
            // console.log(row)
        },
        // 结束营业
        closebusiness() {
            localStorage.removeItem('userInfo');
            localStorage.removeItem('TOKEN');
            this.$router.push({ path: '/login' });
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getTableList();
        this.getDishesType();
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
* {
    margin: 0;
    padding: 0;
}
.memberDetails{
    display: flex;
    margin: 12px 68px;
    align-items: center;
}
.inputStyle{
    width: 350px;
    margin-left: 12px;
}
.content {
    background: #eee;
    height: calc(100vh - 102px);
    padding: 20px;
    /* padding-bottom: 20px; */

}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgb(139, 188, 247);
    padding: 0 30px;
}



.table {
    padding: 20px;
    background: #fff;
    /* height: calc(100vh - 200px); */
    height: calc(100vh - 110px);
    position: relative;
    box-sizing: border-box;
    overflow-y: scroll;
}


.table_item {
    background: rgb(245, 245, 245);

}

.is_free div {
    border: 1px solid #eee;
}

.useing div:nth-child(1) {
    background: rgb(55, 88, 255);
    color: #fff;
}

.no_use div {
    border: 1px solid #d50f0f;
}

.useing div:nth-child(2) {
    background: #fff;
    color: red;
    border: 1px solid rgb(55, 88, 255);
}

.no_use div:nth-child(1) {
    background: #d50f0f;
    color: #fff;
}

.no_use div:nth-child(2) {
    background: #d50f0f;
    color: #fff;
}

.is_free div {
    background: rgb(245, 245, 245);
}

.is_free div:nth-child(1) {
    font-weight: bold;
}

.table_item div {
    /* width: 200px; */
    line-height: 60px;
    text-align: center;
}

.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.el-col {
    border-radius: 4px;
    margin-bottom: 20px;

}

.bg-purple-dark {
    background: blue;
}


.bg-purple-light {
    background: #ff6700;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
}

.table_num {
    background: #ff6700;
    cursor: pointer;
}

.button {
    position: absolute;
    bottom: 30px;
    left: -30px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.button button {
    min-width: 100px;
    line-height: 40px;
}

.dialog-footer button {
    width: 100px;
    line-height: 40px;
}

.el-dialog__body {
    border-top: 1px solid #ff6700;
}

.table_set {}

.confirm {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.confirm button {
    width: 100px;
    line-height: 40px;
}

.el-radio {
    margin-right: 20px;
}

.tableDetail {}

.table_info {
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.table_infos {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.table_btn .btn {
    min-width: 80px;
    line-height: 40px;
}

.table_people_num {
    min-width: 100px;
    text-align: center;
    border-right: 1px solid #333;
    padding: 0 10px;
}

.table_people_num:nth-child(3) {
    border-right: none;
}

.table_people_num div:nth-child(1) {
    line-height: 40px;
    font-size: 16px;
    font-weight: 600;
}

.table_people_num div:nth-child(2) span {
    font-size: 20px;
    font-weight: bold;
}

.num_color {
    color: red;
}

.order_list {
    height: 300px;
    overflow-y: scroll;
    /* overflow: hidden; */
}

.table_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 40px 0;
}

.bold {
    display: inline-block;
    width: 5px;
    background: rgb(67, 147, 245);
    height: 25px;
    margin-right: 10px;
}

.order_info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 40px;
    margin-bottom: 20px;
}

.order_info span {
    color: rgb(255, 145, 24);
    font-size: 16px;
}

.order_info span:nth-child(2) {
    margin: 0 20px 0 15px;
    color: #333;
    font-weight: bold;
}

.order_info span:nth-child(3) {
    color: red;
    font-weight: bold;
}

.num_tip {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.el-icon-minus,
.el-icon-plus {
    width: 30px;
    line-height: 30px;
    border: 1px solid #409EFF;
    color: #409EFF;
    font-weight: bold;
}

.checkout {}

.checkout_type {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.pay {
    width: 150px;
    height: 150px;
    line-height: 150px;
    border: 1px solid #333;
    text-align: center;
}

.payActive {
    border: 1px solid rgb(55, 88, 255);
    color: rgb(55, 88, 255);
}

.checkout_info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 30px 0;
    font-weight: bold;
}

.price {
    margin-left: 30px;
}

.price .input {
    width: 80px;
    font-size: 16px;
    color: red;
    font-weight: bold;
}

.price span:nth-child(1) {
    font-size: 16px;
    margin-right: 10px;
}

.price span:nth-child(2) {
    color: red;
}

.el-icon-edit {
    font-size: 16px;
    font-weight: bold;
    margin-left: 20px;
}

.btns {
    width: 100px;
    line-height: 40px;
    text-align: center;
    margin-left: 40px;
}

.dining {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.dining_num {
    width: 150px;
    font-size: 18px;
    text-align: center;
}

.edit {
    margin-left: 5px;
}

.dining_num div:nth-child(2) span {
    font-size: 20px;
}


.color_red {
    color: red;
}

.useinput {
    background: #409EFF;
}

.dining_info {
    margin-top: 40px;
    /* line-height: 40px; */
}

.dining_info h3 {
    line-height: 40px;
}

.order {
    background: #eee;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 5px;
    height: 80vh;

}

.classification {
    background: #fff;
    width: 10%;
    text-align: center;
    line-height: 40px;
}

.dishes_active {
    background: #409EFF;
    color: #fff;
}

.goods {
    width: 47%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}

.good_item {
    padding: 20px;
    margin: 0 10px 10px 0;
}

.good_img_div {
    position: relative;
}

.good_img_div div {
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    line-height: 20px;
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 12px;
    bottom: 0;
}

.good_img {
    width: 100px;
    height: 60px;
    vertical-align: top;
}

.good_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.good_name {
    width: 100px;
    overflow: hidden;
    height: 40px;
    text-overflow: ellipsis;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical
}

.good_info span {
    font-size: 14px;
    color: red;
    font-weight: bold;
}

.el-icon-shopping-cart-2 {
    font-size: 20px;
    color: #409EFF;
}



.good_item {
    background: #fff;
    padding: 10px;
}

.add_order {
    width: 40%;
    background: #fff;
    padding: 0 10px;
    position: relative;
    height: 80vh;
}

.add_order_tip {
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
}

.add_goods {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    overflow: hidden;
}

.count_info {
    padding: 20px 40px;
    background: rgb(142, 191, 250);
    width: 70%;
    box-sizing: border-box;
}

.goods_order_num {
    font-size: 20px;
}

.goods_order_nums {
    font-size: 20px;
    margin-top: 20px;
    font-weight: bold;
}

.goods_order_nums span:nth-child(2) {
    color: red;
}

.immediately {
    background: rgb(55, 88, 235);
    width: 30%;
    text-align: center;
    line-height: 113px;
    font-size: 20px;
    color: #fff;
}

.el-dialog__body {
    padding-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/home/home.vue